module.exports = __webpack_public_path__ + "static/img/icon_j2.fbd884fb.png";